import { render, staticRenderFns } from "./CommandUserList.vue?vue&type=template&id=a3996d8a&scoped=true"
import script from "./CommandUserList.vue?vue&type=script&lang=js"
export * from "./CommandUserList.vue?vue&type=script&lang=js"
import style0 from "./CommandUserList.vue?vue&type=style&index=0&id=a3996d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3996d8a",
  null
  
)

export default component.exports